import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ListItemText,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useEffect, useMemo, useState } from 'react';
const EditMatrikelDataDialog = ({
  open,
  onClose,
  address = '',
  initialState = {},
  overwriteData = {},
  heatInstallationList = [],
  buildingUseList = [],
  saveChanges,
  handleDelete,
}) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    setState(initialState);
  }, [initialState]);

  const isEdited = useMemo(() => {
    // If the state is the same as the initial state, return false
    if (JSON.stringify(state) === JSON.stringify(initialState)) {
      return false;
    }
    // If the state is different from the initial state, return true
    return true;
  }, [state, initialState]);

  const handleSaveChanges = () => {
    saveChanges(state);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Indstillinger for {address}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <TextField
            label={`Bygningsår ${
              overwriteData?.AverageBuildingYear ? '(Redigeret)' : ''
            }`}
            value={state.AverageBuildingYear ?? ''}
            onChange={(e) => handleChange(e)}
            fullWidth
            variant="filled"
            name="AverageBuildingYear"
          />
          <TextField
            label={`Bygningsareal ${
              overwriteData?.SumBuildingArea ? '(Redigeret)' : ''
            }`}
            value={state.SumBuildingArea ?? ''}
            onChange={(e) => handleChange(e)}
            fullWidth
            variant="filled"
            name="SumBuildingArea"
          />
          <ListItemText
            primary="Bygningsanvendelse"
            secondary="Vælg den kategori din bygning primært bliver brugt til."
          />
          <TextField
            select
            label={`Bygningsanvendelse ${
              overwriteData?.ExtractedBuildingUse ? '(Redigeret)' : ''
            }`}
            value={state.ExtractedBuildingUse ?? ''}
            onChange={(e) => handleChange(e)}
            fullWidth
            variant="filled"
            name="ExtractedBuildingUse"
          >
            <MenuItem key={0} value={''}>
              ...
            </MenuItem>
            {buildingUseList.map((buildingUse, index) => (
              <MenuItem key={index + 1} value={buildingUse}>
                {buildingUse}
              </MenuItem>
            ))}
          </TextField>
          <ListItemText
            primary="Varmeanlæg"
            secondary="Vælg den varmeløsning din bygning primært bruger."
          />
          <TextField
            select
            label={`Varmeanlæg ${
              overwriteData?.ExtractedHeatInstallation ? '(Redigeret)' : ''
            }`}
            value={state.ExtractedHeatInstallation ?? ''}
            onChange={(e) => handleChange(e)}
            fullWidth
            variant="filled"
            name="ExtractedHeatInstallation"
          >
            <MenuItem key={0} value={''}>
              ...
            </MenuItem>
            {heatInstallationList.map((installation, index) => (
              <MenuItem key={index + 1} value={installation}>
                {installation}
              </MenuItem>
            ))}
          </TextField>
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  state.VerificationFlag !== undefined
                    ? state.VerificationFlag
                    : false
                }
                onChange={(e) =>
                  handleChange({
                    target: { name: e.target.name, value: e.target.checked },
                  })
                }
                name="VerificationFlag"
              />
            }
            label="Klar til benchmarking"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Afbryd
        </Button>
        <Button variant="contained" onClick={handleDelete}>
          Gendan fra BBR
        </Button>
        <Button
          variant="contained"
          onClick={handleSaveChanges}
          disabled={!isEdited}
        >
          Gem ændringer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditMatrikelDataDialog;
